import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/site/Navbar';
import Footer from '../components/site/Footer';
import Seo from '../components/Seo';
import { Button } from '../components/ui/button';
import { Home, Briefcase, BookOpen } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <Seo title="Page not found | Hipro Technologies" description="The page you are looking for does not exist." path="/404" noindex />
      <Navbar />
      <div className="pt-40 pb-32 px-5 text-center" data-testid="not-found-page">
        <div className="text-7xl font-extrabold text-orange-500">404</div>
        <h1 className="mt-4 text-2xl sm:text-3xl font-extrabold">This page doesn't exist</h1>
        <p className="mt-3 text-slate-400 max-w-md mx-auto">The link may be outdated or mistyped. Here's where you probably want to go:</p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/"><Button data-testid="nf-home-btn" className="bg-orange-500 hover:bg-orange-600 rounded-full"><Home className="h-4 w-4 mr-1.5" /> Home</Button></Link>
          <Link to="/careers"><Button variant="outline" className="rounded-full border-white/20 bg-transparent text-white hover:bg-white/10"><Briefcase className="h-4 w-4 mr-1.5" /> Careers</Button></Link>
          <Link to="/blog"><Button variant="outline" className="rounded-full border-white/20 bg-transparent text-white hover:bg-white/10"><BookOpen className="h-4 w-4 mr-1.5" /> Blog</Button></Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
